import { createI18n } from 'vue-i18n'
import ar from './locales/ar.json'
import de from './locales/de.json'
import en from './locales/en.json'
import es from './locales/es.json'
import et from './locales/et.json'
import fr from './locales/fr.json'
import hi from './locales/hi.json'
import id from './locales/id.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'
import lo from './locales/lo.json'
import ms from './locales/ms.json'
import pt from './locales/pt.json'
import ru from './locales/ru.json'
import th from './locales/th.json'
import vi from './locales/vi.json'
import zh from './locales/zh.json'

const messages = {
  ar,
  de,
  en,
  es,
  et,
  fr,
  hi,
  id,
  ja,
  ko,
  lo,
  ms,
  pt,
  ru,
  th,
  vi,
  zh
}

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
})

export default i18n
